import { render, staticRenderFns } from "./CoverBikeData.vue?vue&type=template&id=6a5706ea&scoped=true&"
import script from "./CoverBikeData.vue?vue&type=script&lang=js&"
export * from "./CoverBikeData.vue?vue&type=script&lang=js&"
import style0 from "./CoverBikeData.vue?vue&type=style&index=0&id=6a5706ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5706ea",
  null
  
)

export default component.exports